import { render, staticRenderFns } from "./childTable.vue?vue&type=template&id=4ba2469c"
import script from "./childTable.vue?vue&type=script&lang=js"
export * from "./childTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports